import axios from "axios";

class Api {
  getOrder(id) {
    return axios.get(`/crypto-auto-change/${id}`);
  }
  emitOrder(id, data) {
    return axios.post(`/crypto-auto-change/${id}`, data);
  }
}

export default new Api();
